import * as R from "ramda";
import * as React from "react";
import styled from "styled-components";

import { ItemLabel } from "../../../../../../App/Common/Components/FormComponents";
import { ICourseResolveDisplayResponse, ICourseVoiceOver } from "../../../../../course-author/types";
import ToggleDisplay from "../../../../../utils/ToggleDisplay";
import FileUpload from "../../../FileUpload";
import { CheckBox, FormContainer, Input } from "../../../FormElements";

export const MarginSpace = styled.div`
  margin-top: 1.5rem;
`;

interface IEditVoiceOverAudioProps {
  changeStartTime: (event: React.ChangeEvent<HTMLInputElement>) => void;
  changeStopTime: (event: React.ChangeEvent<HTMLInputElement>) => void;
  enableVoiceOver: () => void;
  localizedVoiceOver: Nullable<ICourseVoiceOver>;
  submitVOTimes: (event: React.KeyboardEvent) => void;
  uploadVoiceOverAudio: (
    fileInputRef: React.RefObject<HTMLInputElement>,
    linkInputRef: React.RefObject<HTMLInputElement>
  ) => () => void;
  voiceOverFile: Nullable<ICourseResolveDisplayResponse>;
  voiceOverStartTime: Nullable<number>;
  voiceOverStopTime: Nullable<number>;
}

export const EditVoiceOverAudio: React.SFC<IEditVoiceOverAudioProps> = props => (
  <>
    <ItemLabel htmlFor="voice-over-enabled" onClick={props.enableVoiceOver}>
      <CheckBox
        name="voice-over-enabled"
        checked={!R.isNil(props.localizedVoiceOver) && props.localizedVoiceOver.value.enabled}
        type="checkbox"
        onChange={props.enableVoiceOver}
      />
      Voice over enabled
    </ItemLabel>
    <ToggleDisplay shouldDisplay={!R.isNil(props.localizedVoiceOver) && props.localizedVoiceOver.value.enabled}>
      <FileUpload
        fileInputName="upload-voice-over-file"
        linkInputName="upload-voice-over-link"
        uploadFile={props.uploadVoiceOverAudio}
      />
      <div>File: {props.voiceOverFile && props.voiceOverFile.displayName}</div>
      <MarginSpace />
      <FormContainer data-testid="vo-form">
        <ItemLabel htmlFor="voice-over-start">Start Time (seconds)</ItemLabel>
        <Input
          name="voice-over-start"
          value={props.voiceOverStartTime || undefined}
          onChange={props.changeStartTime}
          onKeyDown={props.submitVOTimes}
        />
        <ItemLabel htmlFor="voice-over-stop">End Time (seconds)</ItemLabel>
        <Input
          name="voice-over-stop"
          value={props.voiceOverStopTime || undefined}
          onChange={props.changeStopTime}
          onKeyDown={props.submitVOTimes}
        />
      </FormContainer>
    </ToggleDisplay>
  </>
);
